/* Featured quote slider. Only loaded when a section has two or three quotes. */
if (!customElements.get('eb-featured-quote')) {
  customElements.define(
    'eb-featured-quote',
    class EbFeaturedQuote extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.eb-featured-quote__slide')];
        this.dots = [...this.querySelectorAll('.eb-featured-quote__dot')];
        this.index = 0;
        if (this.slides.length < 2) return;

        this.querySelectorAll('.eb-featured-quote__arrow').forEach((button) => {
          button.addEventListener('click', () => this.go(this.index + Number(button.dataset.dir), true));
        });
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.go(Number(dot.dataset.index), true));
        });

        // Swipe on touch screens.
        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch') return;
          this.startX = event.clientX;
        });
        this.addEventListener('pointerup', (event) => {
          if (this.startX == null) return;
          const dx = event.clientX - this.startX;
          this.startX = null;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
        });

        // Theme editor: show the block being edited.
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i > -1) {
            this.stop();
            this.go(i);
          }
        });

        const delay = Number(this.dataset.autoplay);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (delay && !reduceMotion) {
          this.delay = delay;
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.play());
          this.addEventListener('focusin', () => this.stop());
          this.play();
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      go(target, byUser = false) {
        const count = this.slides.length;
        this.index = (target + count) % count;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('inert', !active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        // A visitor who picks a quote has taken over; stop advancing.
        if (byUser) {
          this.stop();
          this.delay = 0;
        }
      }

      play() {
        if (!this.delay) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.delay);
      }

      stop() {
        clearInterval(this.timer);
      }
    }
  );
}
